// Client-side request throttle: a per-action sliding window kept in memory. It stops accidental double-taps and casual
// spamming and gives instant feedback, and it saves database reads and writes. It is NOT a security boundary on its own
// (anyone can skip the app and call the API), so the same limits are enforced server-side: firestore.rules +
// the burst triggers and rate limiters in functions/index.js.
const hits = new Map<string, number[]>();

/** True if the action may go ahead now (and records it); false once `max` uses happened within `windowMs`. */
export const allowAction = (key: string, max: number, windowMs: number): boolean => {
  const now = Date.now();
  const recent = (hits.get(key) || []).filter(t => now - t < windowMs);
  if (recent.length >= max) {
    hits.set(key, recent);
    return false;
  }
  recent.push(now);
  hits.set(key, recent);
  return true;
};

export const TOO_FAST_MESSAGE = 'You are doing that too quickly. Please wait a moment and try again.';
